import {View} from 'backbone';
import template from 'templates/pageNotFoundTemplate.hbs';

const PageNotFoundView = View.extend({
    el: '#admin-main',
    navId: '',
    sdaPageTitle: 'page not found',
    events: {},
    initialize() {
        const that = this;

        that.render();

        return that;
    },
    render: function render() {
        const that = this;

        that.$el.html(template());

        return that;
    },
});

export default PageNotFoundView;
